import { jsonApi } from '@models/jsonApi';

// Warning : this model is duplicated from container.js
export const model = {
  id: null,
  name: '',
  deployment_methods: [],
  recurring_synchronization_deployment_methods: [],
  deployment_mailing_list: {
    jsonApi: 'hasMany',
    type: 'user',
  },
  recurring_synchronization: false,
  noscript: false,
  include_md5_file_in_deployment_mail: false,
  default_tags_lifetime: 0,
  expiration_users: [],
  force_cookie_secure_setting: 'unforced',
  force_cookie_samesite_setting: 'unforced',
  include_jquery_for_tests: false,
  old_event_support: false,
  recurring_synchronization_conf_expert: false,
  recurring_synch_ftp_cdn: false,
  recurring_synch_update_batch_permanent_link: false,
  recurring_synch_send_email: false,
  recurring_synchronization_mailing_list: [],
  recurring_synchronization_cron_minutes: '*',
  recurring_synchronization_cron_hours: '*',
  recurring_synchronization_cron_days: '*',
  recurring_synchronization_cron_months: '*',
  recurring_synchronization_cron_day_of_week: '*',
  integration_id: null,
  parent_id: null,
  triggers: {
    jsonApi: 'hasMany',
    type: 'tms/web-trigger',
  },
};

jsonApi.define('tms/web-container', model);
